import { render, staticRenderFns } from "./Promotion_ssdt.vue?vue&type=template&id=adc9b88c&scoped=true&"
import script from "./Promotion_ssdt.vue?vue&type=script&lang=js&"
export * from "./Promotion_ssdt.vue?vue&type=script&lang=js&"
import style0 from "./Promotion_ssdt.vue?vue&type=style&index=0&id=adc9b88c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adc9b88c",
  null
  
)

export default component.exports